import { type FC } from 'react';
import { type Control, type FieldErrors, get } from 'react-hook-form-latest';

import { _notNil } from '@/littledash';

import type { TreatmentMethod } from '@/model/Treatment.model';

import ControlledInputWithUnits from '@/components/UI/FormElements/ControlledInputWithUnits';

import type { TreatmentFormField, TreatmentFormUnit } from './TreatmentForm.model';

export interface DosingMethodFieldProps {
  id: string;
  /** FieldValues is intentional — field names are built dynamically from dosing method keys */
  control: Control;
  dosingType: TreatmentMethod;
  field: TreatmentFormField;
  errors: FieldErrors;
  isSubmitting: boolean;
  units: Array<TreatmentFormUnit>;
  unitsDisabled?: boolean;
  allowZero?: boolean;
}

const DosingMethodField: FC<DosingMethodFieldProps> = ({
  id,
  control,
  dosingType,
  field,
  errors,
  isSubmitting,
  units,
  unitsDisabled,
  allowZero = false,
}) => (
  <div
    className="w-50"
    data-test-component="DosingMethodField"
    data-test-element="container"
    data-test-key={field.name}
  >
    <label>
      {field.label} {field.required && '(required)'}
    </label>
    <fieldset className="w-100 relative flex justify-between">
      <ControlledInputWithUnits
        id={id}
        classes="w-100"
        field={field}
        selectRequired={dosingType === 'custom'}
        disabled={isSubmitting}
        hasError={_notNil(get(errors, id))}
        units={units}
        control={control}
        errors={errors}
        unitsDisabled={unitsDisabled}
        tooltip={id === 'custom.volume' ? 'When marked as required a value must be entered at dosing' : undefined}
        allowZero={allowZero}
      />
    </fieldset>
  </div>
);

export default DosingMethodField;
